var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_wrapper container-fluid enterprise_area"},[_c('div',{staticClass:"row profile_header page_header enterprise_header"},[_c('enterprises-intern-header')],1),_vm._v(" "),_c('div',{staticClass:"row enterprise_content"},[_c('enterprises-intern-edit-content')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }